module.exports = __webpack_public_path__ + "assets/img/new-pop-bg.458d9468.png";